import { UserInteractionOutcome } from '@nimbus-library/features/agent-assistant/models/agent-assistant.model';
import { ChatChannelType } from '@nimbus-library/features/shared/models/participant-info/i-combined-conversation.response';
import { UserSessionState } from '@nimbus-global/features/reportingLiveData/models/user-session.model';

const twilioChatChannels: ChatChannelType[] = [ChatChannelType.TwilioWhatsapp, ChatChannelType.TwilioSms, ChatChannelType.TwilioRcs];

const userSessionChatEnabledStates: UserSessionState[] = [
  UserSessionState.Ongoing,
  UserSessionState.Parked,
  UserSessionState.InAfterCallWork,
  UserSessionState.InExtendedAfterCallWork,
];

const userInteractionChatEnabledStates: UserInteractionOutcome[] = [
  UserInteractionOutcome.Ongoing,
  UserInteractionOutcome.Parked,
  UserInteractionOutcome.InAfterCallWork,
  UserInteractionOutcome.InExtendedAfterCallWork,
];

const chatInputDisabledStates: UserInteractionOutcome[] = [
  UserInteractionOutcome.Parked,
  UserInteractionOutcome.InAfterCallWork,
  UserInteractionOutcome.InExtendedAfterCallWork,
];

export function isChatInputDisabledForTaskState(state?: UserInteractionOutcome): boolean {
  return chatInputDisabledStates.includes(state);
}

export function isTwilioChatChannelEnabled(channel?: ChatChannelType): boolean {
  return twilioChatChannels.includes(channel);
}

export function isUserSessionLiveChatEnabled(channel?: ChatChannelType, state?: UserSessionState): boolean {
  return isTwilioChatChannelEnabled(channel) && userSessionChatEnabledStates.includes(state);
}

export function isUserInteractionChatEnabled(channel?: ChatChannelType, subState?: UserInteractionOutcome): boolean {
  return isTwilioChatChannelEnabled(channel) && userInteractionChatEnabledStates.includes(subState);
}
